import {USER_LOGGED_IN, USER_NOT_LOGGED_IN, USER_CHECK_LOGIN} from 'constants/actiontypes';
import Config from 'config';

const INITIAL_STATE = {
  loggedIn: false,
  user: null,
  loginURL: Config.AUTH_SERVER,
  checking: false,
  checked: false
};

export default (state=INITIAL_STATE, action) => {
  switch(action.type) {
    case USER_CHECK_LOGIN:
      return Object.assign({}, state, {
        checking: true,
        checked: false,
      });
    case USER_LOGGED_IN:
      return Object.assign({}, state, {
        loggedIn: true,
        user: action.data,
        checked: true,
        checking: false,
      });
    case USER_NOT_LOGGED_IN:
      return Object.assign({}, INITIAL_STATE, {
        url: action.url || Config.BASE_PATH + '/auth/login',
        checked: true,
        checking: false,
        loggedIn: false
      });
    default: return state;
  }
};



/** WEBPACK FOOTER **
 ** ./reducers/user.js
 **/